import { applyMiddleware, compose } from "redux";
import { legacy_createStore as createStore } from "redux";
import { persistStore, persistReducer, createTransform } from "redux-persist";
import RootReducer from "./reducers/RootReducer";
import thunk from "redux-thunk";
import storage from "redux-persist/lib/storage";

// Never restore search mode or filtered search results across refresh.
const clearOrdersSearchTransform = createTransform(
  (inboundState) => ({
    ...inboundState,
    searched: false,
    searchKeyword: "",
  }),
  (outboundState) => ({
    ...outboundState,
    searched: false,
    searchKeyword: "",
  }),
  { whitelist: ["orders"] },
);

const persistConfig = {
  key: "root",
  storage,
  transforms: [clearOrdersSearchTransform],
};
const persistedReducer = persistReducer(persistConfig, RootReducer);

const composeEnhancers =
  process.env.NODE_ENV === "development"
    ? // eslint-disable-next-line global-require
      require("redux-devtools-extension").composeWithDevTools
    : compose;

const Store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(thunk))
);
const Persistor = persistStore(Store);

export { Store, Persistor };
